export const GET_FILE_REPLAY_DASHBOARD_DATA = 'GET_FILE_REPLAY_DASHBOARD_DATA';
export const SET_FILE_REPLAY_DASHBOARD_DATA = 'SET_FILE_REPLAY_DASHBOARD_DATA';
export const GET_REPLAY_FILE_DETAILS = 'GET_REPLAY_FILE_DETAILS';
export const SET_REPLAY_FILE_DETAILS = 'SET_REPLAY_FILE_DETAILS';
